


import Feature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import LineString from 'ol/geom/LineString';
import Map from 'ol/Map.js';
import View from 'ol/View.js';
import Overlay from 'ol/Overlay.js';
import OSM from 'ol/source/OSM.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { Vector as VectorSource,TileImage } from 'ol/source.js';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text, Icon } from 'ol/style.js';

import {getMonthTHFromInt,getMainCookie,checkStatus,setLoader,squareDist,checkText,getFullDate, getSrcLongdo} from '../../../../../util/util';
import {AlertCommit, Alert} from '../../../../Modals/AlertBar';
import {fromLonLat} from 'ol/proj.js';
import { defaultColors as m_CarColor, defaultIcons as m_CarIcon, mapColors as m_CarMapColors } from '../../../UserControl/IconColorPicker/IconColorPicker';


import $ from  'jquery';
let token = "";
const raster = new TileLayer({
  //source: new OSM()
  visible:false,
  source: new TileImage({ url: 'http://mt{0-3}.googleapis.com/vt?lyrs=m@179000000&hl=en&&x={x}&y={y}&z={z}' })
});

let longdo = new TileLayer({
  visible: true,
  // source: new TileImage({ url: 'http://ms.longdo.com/map/msn-server/img.php?HD=1&zoom={z}&x={x}&y={y}' })
  source: getSrcLongdo()
});

const sat =new TileLayer(
{ 
  visible: false,
  source: new TileImage({ url: 'http://mt{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'  })//'http://khm{0-3}.googleapis.com/kh?v=742&hl=pl&&x={x}&y={y}&z={z}'
})
let traffic = new TileLayer({
  visible: false,
  source: new TileImage({ url: 'https://mstraffic1.longdo.com/mmmap/img.php?mode= _trafficoverlay&HD=1&zoom={z}&x={x}&y={y}' })
});

const textFill = new Fill({
  color: '#fff'
});
const textStroke = new Stroke({
  color: 'rgba(0, 0, 0, 0.6)',
  width: 3
});
const invisibleFill = new Fill({
  color: 'rgba(255, 255, 255, 0.01)'
});
const iconPinTracker = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/pin_car.png',
  scale: 1.1,
  //color: '#8959A8'
}));
const iconPinTracker_l = new Icon(/** @type {module:ol/style/Icon~Options} */({
  anchorXUnits: 'fraction',
  anchorYUnits: 'pixels',
  anchorOrigin: "bottom-left",
  src: 'images/pin/pin_car_l.png'
}));
let iconCar = function (icon,color) {
  if(!icon || icon == null){
    icon = "car-side";
    color = "#5DADE2";
  }
    
  return new Icon(/** @type {module:ol/style/Icon~Options} */({
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    anchorOrigin: "bottom-left",
    src: isInArray(m_CarIcon,icon)?'images/pin/'+icon+'.png':'images/pin/car-side.png',
    anchor: [0.48, -30],
    scale: 1,
    color: isInArray(m_CarColor, color) ? m_CarMapColors[color] : color.indexOf("#")>-1?color: "#ff0000"
  }));
}

let container = null;
let content = null;
let closer = null;

let overlay = null;



let styleLineFunction = function(feature,resolution) {
  
  let styles = [
    // linestring
    new Style({
      stroke: new Stroke({
        color: '#ff0000',
        width: 5
      })
    })
  ];

  

  return styles;
};

let styleLineFunction2 = function(feature,resolution) {
  
  let styles = [
    // linestring
    new Style({
      stroke: new Stroke({
        color: '#0000ff',
        width: 5
      })
    })
  ];

  

  return styles;
};


let features = null;
let vector = null;
let startVector = null;
let tmpPointArrow = null;
let carVector = null;
let carSource = null;
let carSource1 = null;

let vector2 = null;
let startVector2 = null;
let tmpPointArrow2 = null;
let carVector2 = null;
let carSource2 = null;

function isInArray(arr,txt){
  let o = arr.filter(a => {
    return a == txt;
  });
  return o.length>0;
}

let map = new Map({
  layers: [],
  overlays: [],
  target: 'mapTrackingHistory',
  view: new View({
    center: fromLonLat([100, 13]),
   // projection: 'EPSG:4326',
    minZoom: 5,
    maxZoom: 19,
    zoom : 6
  })
});

let viewMain = new View({
  center: fromLonLat([100, 13]),
  //projection: 'EPSG:4326',
  minZoom: 5,
  maxZoom: 19,
  zoom: 6
});



function mapOnClick(evt) {
    
  let lonlat = evt.coordinate;
  
  let a = [];
  let feature = map.forEachFeatureAtPixel(evt.pixel,
    function(feature) {
        a.push(feature) ;
    },
    {
      layerFilter: function (layer) {
          return layer.get('name') == 'startVector' || layer.get('name') == 'startVector2' || layer.get('name') =='car';
      },
      hitTolerance: 20
    }
  );
  
  if (a.length > 0) {
    let minDis = squareDist(lonlat,a[0].getGeometry().getCoordinates())
    let coordinates = a[0].getGeometry().getCoordinates();
    let target = a[0];
    for(let i = 1 ; i < a.length ; i++){
      let v = squareDist(lonlat,a[i].getGeometry().getCoordinates());
      if( minDis > v){
        minDis = v;
        coordinates = a[i].getGeometry().getCoordinates();
        target = a[i] ;
      }
        
     }
     let imei = target.get('imei') ;
     let number = target.get('number') ;
     let date = target.get('date') ;
     let time = target.get('time') ;
     let place = target.get('place') ;
     let latitude = target.get('latitude') ;
     let longitude = target.get('longitude') ;
     let speed = target.get('speed') ;
     let driver_name = target.get('driver_name') ;
     let driver_contact = target.get('driver_contact') ;
     let direction = target.get('direction') ;
     let index = target.get('index') ;
 
     $(".balloon-device_no").html(checkText(number,"-",20));
     $(".balloon-time").html(getFullDate(date) + "," + time);
     $(".balloon-place").html(checkText(place,"-",100));
     $(".balloon-position").html(latitude + " , " + longitude);
     $(".balloon-speed").html(checkText(speed,"0"));
     $(".balloon-driver_name").html(checkText(driver_name,"-",15));
     $(".balloon-driver_contact").html(checkText(driver_contact,"-",15));
     $(".balloon-google_map_position").attr('href', 'https://www.google.com/maps/search/?api=1&query=' + latitude + ',' + longitude);
     $(".balloon-street_view_position").attr('href', 'https://www.google.com/maps?q&layer=c&cbll='+latitude+','+longitude+'&cbp=11,0,0,0,0')
     m_props.onSelectCarIndex(index);
    //console.log("imei",imei,date + " " + time)
     fetch("http://203.150.199.244/api/report/getPlaybackTrackDuration", {
        method: 'post',
        headers: {
            "Content-Type": "application/json; charset=utf-8",
            "token":token
            },
        body: JSON.stringify({
          "imei" : imei,
          "dtm" : date + " " + time.split(":")[0]+":"+time.split(":")[1]
          })
    }).then(function(response) {
        return checkStatus(response);
    }).then((data) =>{
      //console.log("imei",data)
      $(".balloon-duration").html(checkText(data.RESULT_DATA.current_status,"-"));
    }, 
    (error) => {
      console.log("error",error)
    }
        
    )

    overlay.setPosition(coordinates);
  }


  
}

function mapOnMouseMove(e) {
  
  // if (e.dragging) {
  //   overlay.setPosition(undefined);
  //   closer.blur();
  //   //return;
  // }
  let pixel = map.getEventPixel(e.originalEvent);
  let hit = map.forEachFeatureAtPixel(pixel, function(feature, layer) {
    return layer.get('name') == 'startVector' || layer.get('name') == 'startVector2'
  },{
    hitTolerance: 20
  });
  $("#mapTrackingHistory").css("cursor", hit ? 'pointer' : '');
}

let startPos = null;
let startStyles = function(features){
  let end = features.getGeometry().getCoordinates();
  let startStyles = [];
  if(startPos == null)
    startPos = end;
  // geometry.forEachSegment(function(start, end) {
    let dx = end[0] - startPos[0];
    let dy = end[1] - startPos[1];
    let rotation = Math.atan2(dy, dx);
    // arrows
    startStyles.push(new Style({
      geometry: new Point(startPos),
      image: new Icon({
        src: './images/pin/history_direction_'+features.get('status')+'.png',
        anchor: [0.75, 0.5],
        rotateWithView: true,
        rotation: -rotation,
        scale: 0.7
      })
    }));
 // });
  startPos = end;
  return startStyles;
}

let startPos2 = null;
let startStyles2 = function(features){
  let end = features.getGeometry().getCoordinates();
  let startStyles = [];
  if(startPos2 == null)
    startPos2 = end;
  // geometry.forEachSegment(function(start, end) {
    let dx = end[0] - startPos2[0];
    let dy = end[1] - startPos2[1];
    let rotation = Math.atan2(dy, dx);
    // arrows
    
    startStyles.push(new Style({
      geometry: new Point(startPos2),
      image: new Icon({
        src: './images/pin/history_direction_'+features.get('status')+'.png',
        anchor: [0.75, 0.5],
        rotateWithView: true,
        rotation: -rotation,
        scale: 0.7
      })
    }));
 // });
  startPos2 = end;
  return startStyles;
}

function intMap(features , pointArrow) {
  console.log("initMap",features , pointArrow)
  vector = new VectorLayer({
    source: new VectorSource({
      features: [features]
    }),
    style: styleLineFunction
  });

  map.addLayer(vector);

  
    
  startPos = null;
  startVector = new VectorLayer({
  //  name: "startVector",
    source: new VectorSource({
      features: pointArrow
    }),
    style: startStyles//(features)
  });
  map.addLayer(startVector);

  tmpPointArrow = new VectorLayer({
    name: "startVector",
    source: new VectorSource({
      features: pointArrow
    }),
   
  });
  map.addLayer(tmpPointArrow);
 

  carSource1 = new VectorSource({
    features: [pointArrow[0]]
  });

  carVector = new VectorLayer({
    name: "car",
    source: carSource1,
    style: createPinGroupOverStyle
  });
  map.addLayer(carVector);

  extentTrack(1);

  
}

function intMap2(features , pointArrow) {
  vector2 = new VectorLayer({
    source: new VectorSource({
      features: [features]
    }),
    style: styleLineFunction2
  });

  map.addLayer(vector2);
    
  startPos2 = null;
  startVector2 = new VectorLayer({
    source: new VectorSource({
      features: pointArrow
    }),
    style: startStyles2//(features)
  });
  map.addLayer(startVector2);

  tmpPointArrow2 = new VectorLayer({
    name: "startVector2",
    source: new VectorSource({
      features: pointArrow
    })
  });
  map.addLayer(tmpPointArrow2);

  carSource2 = new VectorSource({
    features: [pointArrow[0]]
  });

  carVector2 = new VectorLayer({
    name: "car2",
    source: carSource2,
    style: createPinGroupOverStyle
  });
  map.addLayer(carVector2);

  if(m_trackData1.RESULT_DATA[0].tracker.length==0){
    extentTrack(2);
  }
  

  
}


function createPinGroupOverStyle(feature) {
  return [new Style({
    //geometry: feature.getGeometry(),
    image: iconPinTracker,
    text: new Text({
      // fill: textFill,
      // stroke: textStroke,
      font: '12px sans-serif',
      fill: new Fill({ color: '#C60013' }),
      backgroundFill: new Fill({ color: '#FFC689' }),
    
      backgroundStroke: new Stroke({
        color: '#C60013',
        width: 1
      }),
      padding: [1, 3, 1, 3],
      offsetY: -20,
      text: feature.get('number').toString()
    })

  }),
  new Style({
    //geometry: feature.getGeometry(),
    image: feature.get('symbol_id')? iconCar(feature.get('symbol_id').toString(),feature.get('symbol_color').toString()):iconCar(),//อาจช้า
  })];
}

export function setMapToggle(mapTogglePath){
  if(mapTogglePath.indexOf('type_sat.png')>-1){
    mapTogglePath = mapTogglePath.replace('type_sat','type_map');
    if(m_isGoogleMap)
      raster.setVisible(false);
    else
      longdo.setVisible(false);
    sat.setVisible(true);
  }
  else{
    if(m_isGoogleMap)
      raster.setVisible(true);
    else
      longdo.setVisible(true);
    sat.setVisible(false);
     mapTogglePath = mapTogglePath.replace('type_map','type_sat');
  }
  return mapTogglePath;
}

export function setTrafficToggle(trafficTogglePath){
  if(trafficTogglePath.indexOf('traffic.png')>-1){
    trafficTogglePath = trafficTogglePath.replace('traffic','traffic_a');
    traffic.setVisible(true);
  }else{
    trafficTogglePath = trafficTogglePath.replace('traffic_a','traffic');
    traffic.setVisible(false);
  }
  return trafficTogglePath;
}

export function switchBaseMap(isGoogle){
  console.log(isGoogle)
  m_isGoogleMap = isGoogle;
  raster.setVisible(m_isGoogleMap);
  longdo.setVisible(!m_isGoogleMap);
}

let m_isGoogleMap = false;




let m_props=null;
let m_lastLat=null;
let m_lastLong=null;

function setMap(props,jsonCar,num){     
  if(jsonCar.RESULT_DATA.length == 0)
    jsonCar.RESULT_DATA.push( {"tracker": []})
  else if(!jsonCar.RESULT_DATA[0].tracker)
    jsonCar.RESULT_DATA[0].tracker = [];

  let count = jsonCar.RESULT_DATA[0].tracker.length;
  if(num==1){
    m_trackData1 = jsonCar;
    if(m_trackData == null || m_trackData.length == 0)
      m_trackData = m_trackData1
    props.onGetTrackHistoryComplete(jsonCar.RESULT_DATA[0]);
    if(m_trackData1.RESULT_DATA[0].tracker.length > 0)
      $(".cardCarHistoryMain").show();
  }else{
    m_trackData2 = jsonCar;
    if(m_trackData == null || m_trackData.length == 0)
      m_trackData = m_trackData2
    props.onGetTrackHistory2Complete(jsonCar.RESULT_DATA[0]);
    if(m_trackData1.RESULT_DATA[0].tracker.length > 0 || m_trackData2.RESULT_DATA[0].tracker.length > 0 )
      $(".cardCarHistoryMain").show();
    else
      $(".cardCarHistoryMain").hide();
  }
  

  features = [];
  let pointArrow = [];
  if(jsonCar.RESULT_STATUS != "000" && jsonCar.RESULT_STATUS != "404"){
    AlertCommit(false,jsonCar.RESULT_STATUS + ": "+jsonCar.RESULT_MESSAGE);
    return;
  }else if(count == 0){
    let m = jsonCar.RESULT_DATA[0].device_no
    if(m_trackData1 && m_trackData1.RESULT_DATA && m_trackData1.RESULT_DATA[0].tracker.length==0 && num==2)
      m = m_trackData1.RESULT_DATA[0].device_no + ", " + m;
    Alert("ดูย้อนหลัง "+m,"ไม่พบข้อมูลในช่วงเวลาดังกล่าว");
    return;
  }

  
  for (let i = 0; i < count; ++i) {
    if(jsonCar.RESULT_DATA[0].tracker[i].lat != m_lastLat || jsonCar.RESULT_DATA[0].tracker[i].lng != m_lastLong || i<2){//jsonCar.RESULT_DATA[0].tracker[i].status.indexOf("วิ่ง")>-1
      let coordinates = fromLonLat([jsonCar.RESULT_DATA[0].tracker[i].lng, jsonCar.RESULT_DATA[0].tracker[i].lat]);
      features.push(coordinates);
      m_lastLat = jsonCar.RESULT_DATA[0].tracker[i].lat;
      m_lastLong = jsonCar.RESULT_DATA[0].tracker[i].lng;
      pointArrow.push(new Feature(
        {
          labelPoint: new Point(coordinates),
          number: jsonCar.RESULT_DATA[0].device_no?jsonCar.RESULT_DATA[0].device_no:"",
          index: i,
          imei: jsonCar.RESULT_DATA[0].imei?jsonCar.RESULT_DATA[0].imei:"",
          heading: jsonCar.RESULT_DATA[0].tracker[i].heading?jsonCar.RESULT_DATA[0].tracker[i].heading:"",
          status: jsonCar.RESULT_DATA[0].tracker[i].status?jsonCar.RESULT_DATA[0].tracker[i].status:"",
          symbol_id: jsonCar.RESULT_DATA[0].symbol_id?jsonCar.RESULT_DATA[0].symbol_id:"car-side",
          symbol_color: jsonCar.RESULT_DATA[0].symbol_color?jsonCar.RESULT_DATA[0].symbol_color:"#5DADE2",
          latitude: jsonCar.RESULT_DATA[0].tracker[i].lat?jsonCar.RESULT_DATA[0].tracker[i].lat:"",
          longitude: jsonCar.RESULT_DATA[0].tracker[i].lng?jsonCar.RESULT_DATA[0].tracker[i].lng:"",
          speed: jsonCar.RESULT_DATA[0].tracker[i].speed?jsonCar.RESULT_DATA[0].tracker[i].speed:"",
          place: jsonCar.RESULT_DATA[0].tracker[i].place?jsonCar.RESULT_DATA[0].tracker[i].place:"",
          date: jsonCar.RESULT_DATA[0].tracker[i].date?jsonCar.RESULT_DATA[0].tracker[i].date:"",
          time: jsonCar.RESULT_DATA[0].tracker[i].time?jsonCar.RESULT_DATA[0].tracker[i].time:"",
          driver_name: jsonCar.RESULT_DATA[0].tracker[i].driver_name?jsonCar.RESULT_DATA[0].tracker[i].driver_name:"",
          driver_contact: jsonCar.RESULT_DATA[0].tracker[i].driver_contact?jsonCar.RESULT_DATA[0].tracker[i].driver_contact:"",
          direction: jsonCar.RESULT_DATA[0].tracker[i].direction?jsonCar.RESULT_DATA[0].tracker[i].direction:"",
          is_dlt_alert: jsonCar.RESULT_DATA[0].is_dlt_alert?jsonCar.RESULT_DATA[0].is_dlt_alert:"",
          driver_by_tracker: jsonCar.RESULT_DATA[0].tracker[i].driver_by_tracker?jsonCar.RESULT_DATA[0].tracker[i].driver_by_tracker:"",
        }
        ));
      pointArrow[pointArrow.length-1].setGeometryName('labelPoint');
    }
  }
  m_lastLat = null; 
  m_lastLong = null;
  let route = new LineString(features);
  let routeFeature = new Feature({
    type: 'route',
    geometry: route
  });
  
  if(num==1){
    intMap(routeFeature , pointArrow);
    $(".cardCarHistoryred").show();
  }
  else
  {
    intMap2(routeFeature , pointArrow);
    $(".cardCarHistoryblue").show();
  }
}

function getJSONCar(props,timeStart,dateStart,timeEnd,dateEnd,tagsHistory) {
  console.log(timeStart,dateStart,timeEnd,dateEnd,tagsHistory)
  setLoader(true);
  m_props = props;
  let currentComponent = this;
  
  let promises = [];
  for(let i=0;i<tagsHistory.length;i++){
    promises.push(new Promise(
      function(resolve, reject) {
        fetch("http://203.150.199.244/api/report/getPlayback", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "token":token
                },
            body: JSON.stringify({
              "imei" : tagsHistory[i].imei,
              "start_date" : dateStart,
              "start_time" : timeStart,
              "end_date" : dateEnd,
              "end_time" : timeEnd
              })
        }).then(function(response) {
            return checkStatus(response);
        }).then((jsonCar) =>{
            return resolve(jsonCar)
        }, 
        (error) => {
          console.log("error",error)
          setLoader(false);
          return reject(error);
        }
            
        )
      }
    ));
  }
  $(".cardCarHistoryred").hide();
  $(".cardCarHistoryblue").hide();
  map.removeLayer(vector);
  map.removeLayer(tmpPointArrow);
  map.removeLayer(startVector);
  map.removeLayer(carVector);
  map.removeLayer(vector2);
  map.removeLayer(startVector2);
  map.removeLayer(tmpPointArrow2);
  map.removeLayer(carVector2);
  Promise.all(promises).then(function(cars) {
    for(let i=0;i<cars.length;i++){
      setMap(props,cars[i],i+1);
    }

    setLoader(false);
  }).catch(function(err) {
    console.log(err.message); 
    setLoader(false);
  });
  



}

export function updateMapSize(){
  if(map!=null){
    map.updateSize();
  }
}

let animationId = null;
let indexCarTrack = 0;
let m_trackData = [];
let m_trackData1 = [];
let m_trackData2 = [];

function setTrackTime() {
  console.log("setTrackTime",indexCarTrack, m_trackData.RESULT_DATA[0].tracker.length-1)
  if(indexCarTrack >= m_trackData.RESULT_DATA[0].tracker.length-1 || m_trackData.RESULT_DATA[0].tracker.length == 0)
  {
    isHistoryPlay=false;
    stop();
    return;
  }
  let coordinates = fromLonLat([m_trackData.RESULT_DATA[0].tracker[indexCarTrack].lng, m_trackData.RESULT_DATA[0].tracker[indexCarTrack].lat]);
  let car = new Array(1);
  
  for(;indexCarTrack < m_trackData.RESULT_DATA[0].tracker.length-1 ; ){
    ++indexCarTrack;
    if(m_trackData.RESULT_DATA[0].tracker[indexCarTrack].status.indexOf("ดับ") == -1 && m_trackData.RESULT_DATA[0].tracker[indexCarTrack].status.indexOf("เสา") == -1){
      m_props.onSelectCarIndex(indexCarTrack);
      car[0] = new Feature(
        {
          labelPoint: new Point(coordinates),
          number: m_trackData.RESULT_DATA[0].device_no
        }
      );
      car[0].setGeometryName('labelPoint');
    
      carSource.clear();
      carSource.addFeatures([car[0]]);
      carSource.refresh();

      map.getView().setCenter(coordinates)

      break;
    }

  }
 
  
}


function stop() {
  console.log("stop")
  //if (animationId !== null) {
    indexCarTrack = 0;
    clearInterval(animationId);
    animationId = null;
    m_props.onSelectCarIndex(indexCarTrack);
    if(m_trackData && m_trackData.RESULT_DATA && m_trackData.RESULT_DATA[0].tracker.length>0){
      let coordinates = fromLonLat([m_trackData.RESULT_DATA[0].tracker[indexCarTrack].lng, m_trackData.RESULT_DATA[0].tracker[indexCarTrack].lat]);
      let car = new Array(1);
        
      car[0] = new Feature(
        {
          labelPoint: new Point(coordinates),
          number: m_trackData.RESULT_DATA[0].device_no
        }
      );
      car[0].setGeometryName('labelPoint');
      if(carSource==null)
        return;
      carSource.clear();
      carSource.addFeatures([car[0]]);
      carSource.refresh();

      map.getView().setCenter(coordinates)
    }
    
    $("#btnHistoryPlay i").removeClass('fa fa-stop '); 
    $("#btnHistoryPlay i").addClass("fa fa-play"); 
    $("#btnHistoryPlay2 i").removeClass('fa fa-stop '); 
    $("#btnHistoryPlay2 i").addClass("fa fa-play"); 
    //isHistoryPlay=false;
  //}
};

function play() {
  console.log("play",animationId)
  //stop();
  //indexCarTrack = 0;
  let t = m_trackData.RESULT_DATA[0].tracker.filter(t=>{
    if(t.status.indexOf("จอด")>-1 || t.status.indexOf("วิ่ง")>-1)
      return t;
  });
  if(t.length > 0){
    animationId = setInterval(setTrackTime, 500 / 1);
  }else{
    Alert("ดูย้อนหลัง "+m_trackData.RESULT_DATA[0].device_no,"ดับเครื่องหรือไม่พบสัญญาน ในช่วงเวลาดังกล่าว");
    isHistoryPlay = false;
    stop();
  }
  
};

let isHistoryPlay = false;
export function visibleTrack(n,isVisible){
  if(n==1){
    if(vector!==null){
      vector.setVisible(isVisible);
      startVector.setVisible(isVisible);
      carVector.setVisible(isVisible);
      tmpPointArrow.setVisible(isVisible);
    }   
  }
  else{
    if(vector2!==null){
      vector2.setVisible(isVisible);
      startVector2.setVisible(isVisible);
      carVector2.setVisible(isVisible);
      tmpPointArrow2.setVisible(isVisible);
    }
    
  }

}

function extentTrack(n){
  let extent = null;
  if(n==1){
    if(vector!==null){
      vector.setZIndex(1);
      startVector.setZIndex(1);
      carVector.setZIndex(1);
      extent = vector.getSource().getExtent();

      carSource = carSource1;
      $(".cardCarHistory").removeClass('active'); 
      $(".cardCarHistory.red").addClass('active'); 
    }
    
    if(vector2!==null){
      vector2.setZIndex(0);
      startVector2.setZIndex(0);
      carVector2.setZIndex(0);
    }
  }
  else{
    if(vector!=null){
      vector.setZIndex(0);
      startVector.setZIndex(0);
      carVector.setZIndex(0);
    }
    if(vector2!=null){
      vector2.setZIndex(1);
      startVector2.setZIndex(1);
      carVector2.setZIndex(1);
      extent = vector2.getSource().getExtent();

      carSource = carSource2;
      $(".cardCarHistory").removeClass('active'); 
      $(".cardCarHistory.blue").addClass('active'); 
    }
    
  }
    
  map.getView().fit(extent, map.getSize());
}

export function zoomExtent(n){
  
  extentTrack(n);
  clearInterval(animationId);
  animationId = null;
  $("#btnHistoryPlay i").removeClass('fa fa-stop '); 
  $("#btnHistoryPlay i").addClass("fa fa-play"); 
  $("#btnHistoryPlay2 i").removeClass('fa fa-stop '); 
  $("#btnHistoryPlay2 i").addClass("fa fa-play"); 
  isHistoryPlay=false;
}

export function zoomTo(index,lat,lng){
  let coordinates = fromLonLat([lng, lat]);
  indexCarTrack = index;
  let car = new Array(1);
      
  car[0] = new Feature(
    {
      labelPoint: new Point(coordinates),
      number: m_trackData.RESULT_DATA[0].device_no,

      index: index,
      imei: m_trackData.RESULT_DATA[0].imei?m_trackData.RESULT_DATA[0].imei:"",
      heading: m_trackData.RESULT_DATA[0].tracker[index].heading?m_trackData.RESULT_DATA[0].tracker[index].heading:"",
      status: m_trackData.RESULT_DATA[0].tracker[index].status?m_trackData.RESULT_DATA[0].tracker[index].status:"",
      symbol_id: m_trackData.RESULT_DATA[0].symbol_id?m_trackData.RESULT_DATA[0].symbol_id:"car-side",
      symbol_color: m_trackData.RESULT_DATA[0].symbol_color?m_trackData.RESULT_DATA[0].symbol_color:"#5DADE2",
      latitude: m_trackData.RESULT_DATA[0].tracker[index].lat?m_trackData.RESULT_DATA[0].tracker[index].lat:"",
      longitude: m_trackData.RESULT_DATA[0].tracker[index].lng?m_trackData.RESULT_DATA[0].tracker[index].lng:"",
      speed: m_trackData.RESULT_DATA[0].tracker[index].speed?m_trackData.RESULT_DATA[0].tracker[index].speed:"",
      place: m_trackData.RESULT_DATA[0].tracker[index].place?m_trackData.RESULT_DATA[0].tracker[index].place:"",
      date: m_trackData.RESULT_DATA[0].tracker[index].date?m_trackData.RESULT_DATA[0].tracker[index].date:"",
      time: m_trackData.RESULT_DATA[0].tracker[index].time?m_trackData.RESULT_DATA[0].tracker[index].time:"",
      driver_name: m_trackData.RESULT_DATA[0].tracker[index].driver_name?m_trackData.RESULT_DATA[0].tracker[index].driver_name:"",
      driver_contact: m_trackData.RESULT_DATA[0].tracker[index].driver_contact?m_trackData.RESULT_DATA[0].tracker[index].driver_contact:"",
      direction: m_trackData.RESULT_DATA[0].tracker[index].direction?m_trackData.RESULT_DATA[0].tracker[index].direction:"",
      is_dlt_alert: m_trackData.RESULT_DATA[0].is_dlt_alert?m_trackData.RESULT_DATA[0].is_dlt_alert:"",
      driver_by_tracker: m_trackData.RESULT_DATA[0].tracker[index].driver_by_tracker?m_trackData.RESULT_DATA[0].tracker[index].driver_by_tracker:"",
    }
  );
  car[0].setGeometryName('labelPoint');

  carSource.clear();
  carSource.addFeatures([car[0]]);
  carSource.refresh();
  map.getView().setCenter(coordinates);
  map.getView().setZoom(15);
  
  clearInterval(animationId);
  animationId = null;
  $("#btnHistoryPlay i").removeClass('fa fa-stop '); 
  $("#btnHistoryPlay i").addClass("fa fa-play"); 
  $("#btnHistoryPlay2 i").removeClass('fa fa-stop '); 
  $("#btnHistoryPlay2 i").addClass("fa fa-play"); 
  isHistoryPlay=false;
}

export function clearMapTrackingHistory() {
  longdo.setVisible(true);
  sat.setVisible(false);
  traffic.setVisible(false);
  if(m_props!=null)
    stop();
  map=null;
  isHistoryPlay=false;
  animationId=null;
  m_props=null;
  indexCarTrack=0;
  m_trackData=null;
  m_trackData1=null;
  m_trackData2=null;
  $( "#btnHistoryPlay").unbind( "click" );
  $( "#btnHistoryPlay2").unbind( "click" );
  $( ".cardCarHistory").unbind( "click" );
  console.log("ClearMapTracking",isHistoryPlay);
}

export function setDefaultMap(){
  container = document.getElementById('mapTrackingHistoryPopup');
  content = document.getElementById('mapTrackingHistoryPopupContent');
  closer = document.getElementById('mapTrackingHistoryPopupCloser');

  $("#mapTrackingHistoryPopup").show();
  overlay = new Overlay({
    element: container,
    autoPan: true,
    autoPanAnimation: {
      duration: 250
    }
  });
  map = new Map({
    layers: [raster,longdo,sat,traffic],
    overlays: [overlay],
    target: 'mapTrackingHistory',
    view: viewMain
  });

  
  map.on('singleclick', mapOnClick);
  map.on('pointermove', mapOnMouseMove);
  if(closer!=null){
    closer.onclick = function() {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };
  }
  
}

export default function mapTrackingHistory(props,timeStart,dateStart,timeEnd,dateEnd,tagsHistory) {
  //map=null;
  token = getMainCookie().token;
  getJSONCar(props,timeStart,dateStart,timeEnd,dateEnd,tagsHistory);
  $( ".cardCarHistory").unbind( "click" );
  $(".cardCarHistory").click(function() {
    $(".cardCarHistory").removeClass('active'); 
    $(this).addClass('active'); 
  });
  $( "#btnHistoryPlay").unbind( "click" );
  $( "#btnHistoryPlay" ).click(function() {
    m_trackData = m_trackData1;
    console.log("isHistoryPlay1",isHistoryPlay,m_trackData.RESULT_DATA[0].tracker.length)
    if(m_trackData.RESULT_DATA[0].tracker.length==0)
      return;
    
    if(!isHistoryPlay){
      props.onCarHistorySelect(1);
      $("#btnHistoryPlay i").removeClass('fa fa-play'); 
      $("#btnHistoryPlay i").addClass('fa fa-stop '); 

      $("#btnHistoryPlay2 i").removeClass('fa fa-stop'); 
      $("#btnHistoryPlay2 i").addClass('fa fa-play'); 
      isHistoryPlay = true;
      play();
      
    }
    else{      
        isHistoryPlay = false; 
        stop();
        
    }
    $(".cardCarHistory").removeClass('active'); 
    $(".red").addClass('active'); 
    extentTrack(1);
  });

  $( "#btnHistoryPlay2").unbind( "click" );
  $( "#btnHistoryPlay2" ).click(function() {
    m_trackData = m_trackData2;
    console.log("isHistoryPlay2",isHistoryPlay,m_trackData.RESULT_DATA[0].tracker.length)
    if(m_trackData.RESULT_DATA[0].tracker.length==0)
      return;
    
    if(!isHistoryPlay){
        props.onCarHistorySelect(2);
        $("#btnHistoryPlay2 i").removeClass('fa fa-play'); 
        $("#btnHistoryPlay2 i").addClass('fa fa-stop '); 

        $("#btnHistoryPlay i").removeClass('fa fa-stop'); 
        $("#btnHistoryPlay i").addClass('fa fa-play');
        isHistoryPlay = true;
        play();
        
    }
    else{       
      isHistoryPlay = false;
      stop();
        
    }
    $(".cardCarHistory").removeClass('active'); 
    $(".blue").addClass('active'); 
    extentTrack(2);
  });
  


}







// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/MapTrackingHistory/js/MapTrackingHistory.js